module.exports = "https://r.nearpod.com/assets/media/image/home-77d3b96646f715d2396044f5ce50aee0.svg";